import React, { useMemo, useState } from "react";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";

export default function ConfirmPayment({
  onClose,
  orderTotal ,
  onPay = () => {},
}) {
  
  const tipOptions = [5, 10, 15, 20]; // tip percentages
  const [selectedTip, setSelectedTip] = useState(0);

  // Calculate tip amount and total
  const { tipAmount, totalToPay } = useMemo(() => {
    const tip = (Number(orderTotal) * selectedTip) / 100;
    const total = Number(orderTotal) + tip;
    return {
      tipAmount: Math.round(tip * 100) / 100,
      totalToPay: Math.round(total * 100) / 100,
    };
  }, [orderTotal, selectedTip]);

  const fmt = (v) =>
    typeof Intl !== "undefined"
      ? new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(v)
      : `$${v.toFixed(2)}`;

  return (
    <div className="p-6">
      <h2
        id="confirm-payment-title"
        className="text-center text-base sm:text-lg font-semibold text-[#2F2F2F]"
      >
        Confirm Payment
      </h2>

      {/* Order total */}
      <div className="mt-4 border-t border-gray-200 pt-4">
        <div className="flex justify-between items-center text-base text-[#2F2F2F] font-medium">
          <div>Order Total:</div>
          <div >{fmt(orderTotal)}</div>
        </div>
      </div>

      {/* Tip selection */}
      <div className="mt-4">
        <p className="text-base font-medium text-gray-800">
          Add tip for delivery partner
        </p>
        <p className="text-sm font-medium text-[#2c3644] mt-1">
          Your generosity is appreciated
        </p>

        <div className="mt-3 grid grid-cols-3 gap-3">
          {tipOptions.slice(0, 3).map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setSelectedTip((s) => (s === t ? 0 : t))}
              className={`rounded-lg py-2 text-sm border ${
                selectedTip === t
                  ? "bg-[#02537F] text-white border-slate-800"
                  : "bg-[#F5F5F5] text-gray-800 border-gray-300"
              } transition`}
              aria-pressed={selectedTip === t}
            >
              {t}%
            </button>
          ))}
        </div>

        <div className="mt-3">
          <button
            type="button"
            onClick={() =>
              setSelectedTip((s) => (s === tipOptions[3] ? 0 : tipOptions[3]))
            }
            className={`w-full rounded-lg py-3 text-sm border ${
              selectedTip === tipOptions[3]
                ? "bg-[#02537F] text-white border-slate-800"
                : "bg-[#F5F5F5] text-gray-800 border-gray-300"
            } transition`}
            aria-pressed={selectedTip === tipOptions[3]}
          >
            {tipOptions[3]}%
          </button>
        </div>
      </div>

      {/* Calculated totals */}
      <div className="mt-4 border-t border-gray-200 pt-4 space-y-1">
        {selectedTip > 0 && (
          <div className="flex justify-between text-sm font-medium text-[#2F2F2F]">
            <div>Tip ({selectedTip}%):</div>
            <div>{fmt(tipAmount)}</div>
          </div>
        )}
        <div className="flex justify-between items-center font-semibold text-[#2F2F2F] ">
          <div className="text-base  ">Total to Pay:</div>
          <div className="text-lg">{fmt(totalToPay)}</div>
        </div>
      </div>

      {/* Buttons */}
      <div className="mt-6 flex gap-3">
        <CustomButton
          onClick={onClose}
          customeClass="customer-light-button h-[40px] text-sm w-full"
        >
          Cancel
        </CustomButton>

        <CustomButton
          onClick={() => onPay(totalToPay, tipAmount)}
          customeClass="customer-dark-button h-[40px] text-sm w-full"
        >
          Pay {fmt(totalToPay)}
        </CustomButton>
      </div>
    </div>
  );
}
